const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light' ? lightTheme : darkTheme),
  },
});

export default getDesignTokens;

export const lightTheme = {
  primary: { main: 'rgb(20, 40, 90,1)', text: 'rgba(16, 106, 165, 1)', light: 'rgb(0, 51, 153,1)', dark: 'rgb(14, 47, 112,1)', fade: 'rgb(0, 109, 255,1)', text: 'rgb(20, 40, 90, 1)' },
  primaryLight: { main: 'rgb(rgb(0, 51, 153,1)' },
  primaryDark: { main: 'rgba(0, 132, 180, 1)', secondary: 'rgba(0, 132, 180, 0.5)', light: 'rgba(26, 73, 163,1)' },
  primaryFade: { main: 'rgba(188, 235, 255, 1)' }, //ex: table header
  primaryDull: { main: 'rgb(239, 250, 255,1)' }, // userName Container

  secondary: { main: 'rgb(255, 204, 0, 1)', secondary: 'rgba(242, 146, 34, 0.5)' },
  secondaryDark: { main: 'rgba(242, 101, 34, 1)' },
  secondaryLight: { main: 'rgba(248, 168, 75, 1)' },
  secondaryFade: { main: 'rgba(255, 244, 232, 1)' },

  userName: { main: 'rgb(140, 140, 140)' },
  tableBg: { main: 'rgba(247, 247, 247, 1)' },
  grey: { main: 'rgba(71, 71, 71, 1)' },
  bgGrey: { main: 'rgb(237, 237, 237)' },
  darkGrey: { main: 'rgba(77, 77, 77, 1)' },
  border: { main: 'rgb(198, 198, 198, 1)', light: 'rgb(123, 133, 158, 1)' },
  grayBg: { main: 'rgba(247, 247, 247, 1)', secondary: 'rgba(237, 237, 237, 1)' },
  dragBg: { main: 'rgba(250, 250, 250, 1)' },
  inputBorder: { main: 'rgba(194, 194, 194, 1)' },
  dark: { main: 'rgba(0, 0, 0, 1)' },
  silver: { main: 'rgba(216, 216, 216, 1)' },
  lightSilver: { main: 'rgba(228, 228, 228, 1)' },
  whiteOrange: { main: 'rgba(255, 244, 232, 1)' },
  aliceBlue: { main: 'rgba(239, 250, 255, 1)' },
  aliceblue2: { main: 'rgba(242, 249, 255, 1)' },
  active: { main: 'rgb(72, 181, 73, 1)' },
  invite: { main: 'rgb(29, 161, 243,1)' },
  deActivate: { main: 'rgb(6, 29, 48,1)' },
  drop: { main: 'rgb(172, 230, 255,1)' },
  background: { main: 'rgba(255, 255, 255, 1)' },
  error: { main: 'rgba(208, 23, 23, 1)', primary: 'rgba(235, 63, 63, 1)', secondary: 'rgba(255, 226, 226, 1)' },
  dropBackg: { main: 'rgb(255,255,255,1)' },
  rowHover: { main: 'rgba(255, 244, 232, 1)' },
  dropfont: { main: 'rgb(82, 82, 82,1)' },
  unblock: { main: 'rgb(0, 166, 50,1)', secondary: 'rgb(25, 149, 44, 1)' },
  warning: { main: 'rgba(240, 35, 35,1)', light: 'rgb(242, 34, 34, 1)' },
  lowDark: { main: 'rgba(12, 35, 53, 1)' },
  cancel: { main: 'rgb(112, 112, 113,1)' },
  text: {
    primary: 'rgba(6, 29, 48, 1)',
    disabled: { main: 'rgba(185, 185, 185, 1)' },
  },
};

export const darkTheme = {
  primary: { main: 'rgba(8, 160, 233, 1)', text: 'rgba(16, 106, 165, 1)' },
  primaryDark: { main: 'rgba(0, 132, 180, 1)' },
  primaryLight: { main: 'rgb(188, 235, 255,1)' },
  primaryFade: { main: 'rgba(188, 235, 255, 1)' },

  secondary: { main: 'rgba(242, 146, 34, 1)' },
  secondaryDark: { main: 'rgba(242, 101, 34, 1)' },
  secondaryLight: { main: 'rgba(248, 168, 75, 1)' },
  secondaryFade: { main: 'rgba(255, 244, 232, 1)' },
  dragBg: { main: 'rgba(250, 250, 250, 1)' },
  tableBg: { main: 'rgba(247, 247, 247, 1)' },
  inputBorder: { main: 'rgba(194, 194, 194, 1)' },
  dark: { main: 'rgba(0, 0, 0, 1)' },
  silver: { main: 'rgba(216, 216, 216, 1)' },
  lightSilver: { main: 'rgba(228, 228, 228, 1)' },
  whiteOrange: { main: 'rgba(255, 244, 232, 1)' },
  aliceBlue: { main: 'rgba(239, 250, 255, 1)' },
  aliceblue2: { main: 'rgba(242, 249, 255, 1)' },
  active: { main: 'rgba(72, 181, 73, 1)' },
  grayBg: { main: 'rgba(247, 247, 247, 1)', secondary: 'rgba(237, 237, 237, 1)' },

  lowDark: { main: 'rgba(12, 35, 53, 1)' },
  background: { main: 'rgba(255, 255, 255, 1)' },

  invite: { main: 'rgb(29, 161, 243,1)' },
  deActivate: { main: 'rgb(6, 29, 48,1)' },
  drop: { main: 'rgb(172, 230, 255,1)' },
  error: { main: 'rgba(208, 23, 23, 1)', primary: 'rgba(235, 63, 63, 1)' },
  dropBackg: { main: 'rgb(255,255,255,1)' },
  rowHover: { main: 'rgba(255, 244, 232, 1)' },
  dropfont: { main: 'rgb(82, 82, 82,1)' },
  text: {
    primary: 'rgba(6, 29, 48, 1)',
    disabled: { main: 'rgba(185, 185, 185, 1)' },
  },
};
